/**
 * Working-here image carousel
 *
 * Simple carousel with prev/next controls and auto-play.
 * Respects prefers-reduced-motion and pauses on hover/focus.
 *
 * @package Interact_26
 */

export const initCarousel = (): void => {
  const track = document.getElementById('careers-carousel-track');
  if (!track) return;

  const slides = track.querySelectorAll('.careers-working-here__slide');
  if (slides.length <= 1) return;

  let currentIndex = 0;
  const total = slides.length;

  const goToSlide = (index: number): void => {
    currentIndex = ((index % total) + total) % total;
    track.style.transform = `translateX(-${currentIndex * 100}%)`;
  };

  const prevBtn = document.querySelector('[data-action="carousel-prev"]');
  const nextBtn = document.querySelector('[data-action="carousel-next"]');

  prevBtn?.addEventListener('click', () => goToSlide(currentIndex - 1));
  nextBtn?.addEventListener('click', () => goToSlide(currentIndex + 1));

  // Respect prefers-reduced-motion — skip auto-play entirely
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (prefersReducedMotion.matches) {
    return;
  }

  // Auto-play every 5 seconds
  let autoplayTimer: ReturnType<typeof setInterval> | null = setInterval(
    () => goToSlide(currentIndex + 1),
    5000,
  );

  const pauseAutoplay = (): void => {
    if (autoplayTimer) {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
    }
  };

  const resumeAutoplay = (): void => {
    if (!autoplayTimer) {
      autoplayTimer = setInterval(() => goToSlide(currentIndex + 1), 5000);
    }
  };

  // Pause auto-play on hover and focus (keyboard a11y)
  const carousel = track.closest('.careers-working-here__carousel');
  if (carousel) {
    carousel.addEventListener('mouseenter', pauseAutoplay);
    carousel.addEventListener('mouseleave', resumeAutoplay);
    carousel.addEventListener('focusin', pauseAutoplay);
    carousel.addEventListener('focusout', resumeAutoplay);
  }

  // Sync auto-play with reduced-motion preference changes
  prefersReducedMotion.addEventListener('change', (e) => {
    if (e.matches) {
      pauseAutoplay();
    } else {
      resumeAutoplay();
    }
  });
};
